import { User } from '@/core/models/user.model';

export class Meeting {
  meetingId: number;
  name: string;
  description: string;
  startingDate: string;
  endingDate: string;
  members: User[];
  type: string;
  archived?: boolean;
  constructor(data: any) {
    this.meetingId = data.meetingId;
    this.name = data.name;
    this.startingDate = data.startingDate;
    this.description = data.description;
    this.endingDate = data.endingDate ? data.endingDate : null;
    this.members = data.members ? data.members : []
    this.archived = data.archived;
    this.type = data.type;
  }
}